module.exports = __webpack_public_path__ + "img/扬沙.071c5623.png";